import { LEGAL_UPDATED } from "./legal";

/** Small "Last updated" note shown at the top of every legal text. */
export function LegalUpdated(): React.JSX.Element {
  return (
    <p className="nb-help" style={{ marginBottom: "var(--space-3)" }}>
      {`Last updated: ${LEGAL_UPDATED}`}
    </p>
  );
}
